import { apiRequest } from './apiClient';

class PasswordResetService {
  static async sendResetOtp(email) {
    return apiRequest({
      endpoint: '/admin/api/public/users/reset-password',
      method: 'POST',
      auth: false,
      headers: {
        accept: '*/*'
      },
      body: { email }
    });
  }

  static async verifyResetOtp({ email, otp, new_password }) {
    return apiRequest({
      endpoint: '/admin/api/public/users/reset-password/verify',
      method: 'POST',
      auth: false,
      headers: {
        accept: 'application/json'
      },
      body: { email, otp, new_password }
    });
  }
}

export default PasswordResetService;
